import React from "react"
import Link from "next/link"
import { Row, Col } from "react-bootstrap"
import classnames from "classnames"
import styles from "./CustomBanner.module.css"

const CustomBanner = ({
  title,
  subtitle,
  buttonText,
  buttonLink,
  buttonTo,
  dates,
  left,
  image,
  moreHeight = false,
}) => {
  const colClass = left ? (moreHeight ? 4 : 6) : 12
  const isLeft = left ? 12 : 4
  const flexColumn = left ? "flex-column" : "flex-row"
  const justifyClass = left ? "justify-content-center" : "align-items-end"

  return (
    <div
      className={classnames(
        styles.bannerBg,
        "d-flex",
        "align-items-center",
        moreHeight ? styles.moreHeight : "",
      )}
      style={{
        backgroundImage: `url(${image})`,
      }}>
      <div className="container-fluid z-1 h-100">
        <Row className="h-100 align-items-end">
          <Col
            xs={12}
            lg={colClass}
            className={classnames(
              styles.bannerInfo,
              "d-flex",
              "align-items-center",
              flexColumn,
              justifyClass,
              "pb-0",
              "h-50",
            )}>
            <Row
              className={classnames(
                "w-100",
                "align-items-center",
                "mx-auto",
                "pb-2",
                "px-2",
                "pt-sm-1",
                "pt-5",
              )}>
              <div>
                <h4
                  className={classnames(
                    styles.white,
                    "d-block",
                    "w-100",
                    "mb-2",
                  )}>
                  {title}
                </h4>
                <h5 className="text-white font-weight-normal mb-0">
                  {subtitle}
                </h5>
                <span className="d-block color-cacaca font-weight-normal mb-2 text-center text-lg-left">
                  {dates}
                </span>
              </div>
            </Row>
            <Row
              className={classnames("w-100", "align-items-center", "mx-auto")}>
              <Col xs={12} lg={isLeft} className="px-2">
                {buttonText && buttonLink && buttonTo ? (
                  <Link
                    href={buttonLink}
                    as={buttonTo}
                    className="text-white text-decoration-underline fs-14px">
                    {buttonText}
                  </Link>
                ) : (
                  <div className="artplacerButtons"></div>
                )}
              </Col>
            </Row>
          </Col>
        </Row>
      </div>
    </div>
  )
}

export default CustomBanner
